import React from "react";
import { DesktopLayout } from "./DekstopLayout";
import { Breakpoint } from "./enums/breakpoint";
import { MobileLayout } from "./MobileLayout";

interface IAppState {
	currAnchor: string;
	currNav: string;
	isMenuClick: boolean;
	screenSize: number;
}

export class App extends React.Component<{}, IAppState> {
	public static readonly BUFFER_ZONE: number = 80;

	private anchors: string[];

	constructor(props = {}) {
		super(props);

		this.state = {
			currAnchor: "",
			currNav: window.location.pathname,
			isMenuClick: false,
			screenSize: window.innerWidth
		}

		// this.positions = {};
		// this.sortedPositions = [];
		this.anchors = [];

		this.childComponentDidMount = this.childComponentDidMount.bind(this);
		this.scrollEventCallback = this.scrollEventCallback.bind(this);
		this.handleScroll = this.handleScroll.bind(this);
		this.handleMenuClick = this.handleMenuClick.bind(this);
		this.handleNavClick = this.handleNavClick.bind(this);
		this.handleResize = this.handleResize.bind(this);
	}

	componentDidMount() {
		const root = document.getElementById("root");

		if (!root) {
			return;
		}

		window.addEventListener("scroll", this.scrollEventCallback);
		window.addEventListener("resize", this.handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener("scroll", this.scrollEventCallback);
		window.removeEventListener("resize", this.handleResize);
	}

	private childComponentDidMount(anchorList: string[]) {
		this.anchors = anchorList;
		this.setState({
			currAnchor: anchorList[0]
		});

		//Reset scroll position
		window.scrollTo({
			top: 0,
			behavior: "auto"
		});
	}

	private handleResize() {
		this.setState({
			screenSize: window.innerWidth
		});
	}

	private scrollEventCallback() {
		const { isMenuClick, currAnchor } = this.state;

		if (isMenuClick && currAnchor) {
			const anchorPoint = document.getElementById(currAnchor);

			if (!anchorPoint) {
				return;
			}

			const distToDestination = Math.abs(anchorPoint.getBoundingClientRect().top);
			const isLast = anchorPoint.getAttribute("attr-is-last");
			const morsel = 10;
			if (distToDestination < morsel || (isLast && distToDestination < window.innerHeight)) {
				this.setState({ isMenuClick: false });
			}

		} else {
			this.handleScroll();
		}
	}

	private handleScroll() {
		let newAnchor = this.state.currAnchor;
		const currScrollPosition = window.scrollY;

		let newAnchorCandidates = this.anchors.filter((anchor: string) => {
			const anchorPoint = document.getElementById(anchor);
			if (!anchorPoint) {
				return null;
			}
			const top = anchorPoint.offsetTop;
			return top < currScrollPosition;
		})

		if (newAnchorCandidates.length) {
			newAnchor = newAnchorCandidates[newAnchorCandidates.length - 1];
		}

		this.setState({
			currAnchor: newAnchor || this.state.currAnchor
		});
	}

	private handleMenuClick(anchor: string) {
		this.setState({
			isMenuClick: true,
			currAnchor: anchor
		})
	}

	private handleNavClick(navItem: string) {
		this.setState({
			currNav: navItem
		});
	}

	render() {
		if (this.state.screenSize <= Breakpoint.MOBILE) {
			return (
				<MobileLayout
					currNav={this.state.currNav}
					currAnchor={this.state.currAnchor}
					handleNavClick={this.handleNavClick}
					handleMenuClick={this.handleMenuClick}
					childComponentDidMount={this.childComponentDidMount}
				/>
			);
		}

		return (
			<DesktopLayout
				currNav={this.state.currNav}
				currAnchor={this.state.currAnchor}
				handleNavClick={this.handleNavClick}
				handleMenuClick={this.handleMenuClick}
				childComponentDidMount={this.childComponentDidMount}
			/>
		);
	}
}
